import React, { useState, useRef } from "react";
import { FiCheck, FiSettings } from "react-icons/fi";
import "./CookieBanner.css";

export default function CookieBanner({ onAcceptAll, onRejectAll, onManage }) {
  const [animClass, setAnimClass] = useState("cb-banner-enter");
  const [visible, setVisible] = useState(true);
  const bannerRef = useRef(null);

  const handleAction = (fn) => {
    setAnimClass("cb-banner-exit");
    setTimeout(() => {
      setVisible(false);
      fn();
    }, 380);
  };

  if (!visible) return null;

  return (
    <div className="cb-banner-wrapper" role="region" aria-label="Cookie consent">
      <div className={`cb-banner ${animClass}`} ref={bannerRef}>
        <div className="cb-banner-inner">
          {/* Content */}
          <div className="cb-content">
            <div className="cb-brand-row">
              <span className="cb-brand-badge">Cloudisian</span>
            </div>
            <h2 className="cb-title">We value your privacy</h2>
            <p className="cb-description">
              We use cookies to enhance your browsing experience, serve personalized
              content, and analyze our traffic. By clicking "Accept All", you consent
              to our use of cookies.{" "}
              <a href="/privacy" tabIndex={0}>Privacy Policy</a>
            </p>
          </div>

          {/* Actions */}
          <div className="cb-actions" role="group" aria-label="Cookie consent options">
            <button
              className="cb-btn cb-btn-accept"
              onClick={() => handleAction(onAcceptAll)}
              aria-label="Accept all cookies"
            >
              <FiCheck aria-hidden="true" />
              Accept All
            </button>
            <button
              className="cb-btn cb-btn-reject"
              onClick={() => handleAction(onRejectAll)}
              aria-label="Reject non-essential cookies"
            >
              Reject
            </button>
            <button
              className="cb-btn cb-btn-manage"
              onClick={onManage}
              aria-label="Manage cookie preferences"
            >
              <FiSettings aria-hidden="true" />
              Manage Preferences
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
